<template>
    <v-card>
        <v-form ref="form" v-model="form">
            <v-card-title>
                Nouvel Utilisateur
            </v-card-title>
            <v-card-text class="text-left">
                <!--<p>Utilisateur d'Idendifiant : <b>Med</b></p>
                <p>Email : <b>Med</b></p>-->
                <v-text-field
                class="my-5"
                label="Nom d'utilisateur"
                v-model="username"
                outlined
                :rules="[rules.required, rules.username]"
                :error-messages="messages.username"
                type="text"
                dense
                persistent-hint hint="Le nom d'utilisateur doit contenir au moins 3 caractères."
                ></v-text-field>
                <v-select outlined dense :items="permissions" v-model="permission" item-text="titre" item-value="id" label="Permission"></v-select>
                <v-text-field
                class="my-5"
                label="Email"
                v-model="email"
                outlined
                :error-messages="messages.email"
                :rules="[rules.required, rules.email]"
                type="text"
                dense
                persistent-hint hint="Vous devez entrer un email valide."
                ></v-text-field>
                <v-text-field
                class="my-5"
                label="Mot de passe"
                v-model="password"
                outlined
                :rules="[rules.required, rules.password]"
                type="password"
                dense
                persistent-hint hint="Veuillez choisir une mot de passe contenant au moins 8 caractères."
                ></v-text-field>
                <v-text-field
                class="my-5"
                label="Confirmer Mot de passe"
                v-model="confirm_password"
                :rules="[rules.required, rules.password ,(this.password === this.confirm_password) || 'Les deux champs devaient être identiques.']"
                outlined
                dense
                type="password"
                ></v-text-field>
                <p><b>Un email de confirmation sera envoyé à l'email inséré pour le vérifier.</b></p>
            </v-card-text>
            <v-card-actions class="py-5">
                <v-spacer></v-spacer>
                <v-btn
                color="primary darken-1"
                text
                @click="$emit('hide')"
                >
                Annuler
                </v-btn>
                <v-btn
                style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); margin-right:10px; color:white;"
                @click="newUser"
                >
                Ajouter
                </v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>
<script>
export default {
        name: 'new-user',
        data: () => ({
            rules: {
                required: value => !!value || 'Ce champs est obligatoire.',
                username: value =>{ 
                    const pattern = /^[A-Za-z0-9]+$/
                    return value.length >= 3 && pattern.test(value) || 'Le nom d\'utilisateur doit être composé au moins de 3 caractères alpha-numériques.'
                },
                password: value => value.length >= 8 || 'Le mot de passe doit contenir au moins 8 caractères.',
                email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Vous devez entrer un email valide.',
            },
            password: '',
            confirm_password: '',
            username: '',
            email: '',
            permission: 0,
            permissions: [],
            messages: {
                username: '',
                email: ''
            },
            form: false,
        }),
        mounted(){
            this.axios
                .get("/users/permissions/list")
                .then(response => {
                    this.permissions = response.data
                })
        },
        methods: {
            newUser(){
                let data = {
                    username : this.username,
                    email : this.email,
                    password : this.password,
                    permission : this.permission,
                    agent_id: 0
                }
                this.messages = {
                    username: '',
                    email: ''
                }
                if(this.$refs.form.validate()){
                    this.axios.post('/user/create', data, {}).then((res) => {
                        if(res.data.error){
                            this.messages[res.data.error] = res.data.message
                        }else{
                            this.$emit('print_message', {color: 'success', text: 'Compte créé avec succès! Vous pouvez le trouvez dans le tableau de gestion des utilisateurs.'})
                            this.$emit('hide')
                        }
                    })
                }
                
            }
        }
}

</script>


// WEBPACK FOOTER //
// src/views/dashboard/users/actions/new.vue